import React from 'react';
import './rem';
import Styles from './styles.css';

export default class Skeleton2 extends React.Component{
    render(){
        return (
            <div className={Styles.XyLoadingbox}>

                <p className={Styles.XyLoadingimage4}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt450}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt300}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingimage4}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt150}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt450}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt300}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt150}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt450}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt300}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt150}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt450}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt300}></p>
                <p className={Styles.XyLoadinghr15}></p>

                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt750}></p>
                <p className={Styles.XyLoadingtxt150}></p>
                <p className={Styles.XyLoadinghr15}></p>


            </div>
        )
    }
}